import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// https://www.npmjs.com/package/rc-table
import RCTable from 'rc-table';
import { useMemo } from 'react';
import styled from 'styled-components';
import clss from 'classnames';
import Skeleton from './SkeletonTable';
import { useCDN } from '@/utils/cdn';
import CustomPagination from '@/components/base/Pagination';
import useLanguage from '@/hooks/useLanguage';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var TableLayout = styled.div.withConfig({
    displayName: "Table__TableLayout",
    componentId: "sc-vzqbdn-0"
})([
    ".ex-table-content{",
    " table{",
    " .ex-table-thead tr th{",
    "}.ex-table-row{&:last-child td{",
    "}td{",
    " &.ex-table-row-expand-icon-cell{",
    "}}}.ex-table-placeholder .empty{",
    " img{",
    "}}.ex-table-expanded-row{.ex-table-content,.skelenton{",
    "}}}}.single-line{.ex-table-content table .ex-table-row td{",
    "}}.hide-column .ex-table-thead{",
    "}"
], {
    "borderRadius": "6px",
    "backgroundColor": "var(--color-box-bg)"
}, {
    "width": "100%"
}, {
    "fontSize": "14px",
    "height": "64px",
    "color": "var(--color-desc-text)",
    "lineHeight": "19px",
    "fontWeight": "400",
    "borderBottomWidth": "1px",
    "borderColor": "var(--color-border)",
    "paddingLeft": "40px",
    "textAlign": "left"
}, {
    "paddingBottom": "17px"
}, {
    "paddingTop": "17px",
    "paddingBottom": "8px",
    "fontSize": "14px",
    "lineHeight": "21px",
    "paddingLeft": "40px"
}, {
    "width": "28px"
}, {
    "height": "400px",
    "textAlign": "center",
    "color": "var(--color-desc-text)",
    "fontSize": "16px",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center"
}, {
    "width": "180px",
    "height": "165px",
    "marginBottom": "20px"
}, {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(251, 251, 251, var(--tw-bg-opacity))"
}, {
    "height": "70px",
    "lineHeight": "19px"
}, {
    "display": "none"
});
function Table(props) {
    var _ref = props || {}, _data = _ref.data, data = _data === void 0 ? [] : _data, _columns = _ref.columns, columns = _columns === void 0 ? [] : _columns, _rowKey = _ref.rowKey, rowKey = _rowKey === void 0 ? 'id' : _rowKey, className = _ref.className, emptyText = _ref.emptyText, hideColumns = _ref.hideColumns, pageOpt = _ref.pageOpt, loading = _ref.loading, indicator = _ref.indicator, expandable = _ref.expandable, skeletonRows = _ref.skeletonRows, layoutClassName = _ref.layoutClassName, rest = _objectWithoutProperties(_ref, [
        "data",
        "columns",
        "rowKey",
        "className",
        "emptyText",
        "hideColumns",
        "pageOpt",
        "loading",
        "indicator",
        "expandable",
        "skeletonRows",
        "layoutClassName"
    ]);
    var translate = useLanguage().translate;
    var getRowKey = useMemo(function() {
        if (typeof rowKey === 'function') {
            return rowKey;
        }
        return function(row) {
            return row[rowKey];
        };
    }, [
        rowKey
    ]);
    var getEmptyText = useMemo(function() {
        if (typeof emptyText === 'function') {
            return emptyText;
        }
        var defaultEmpty = function() {
            /*#__PURE__*/ return _jsxs("div", {
                className: "empty",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: useCDN('/img/empty.png'),
                        alt: "empty"
                    }),
                    emptyText || translate('tableEmpty')
                ]
            });
        };
        return defaultEmpty;
    }, [
        emptyText
    ]);
    return(/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            loading ? indicator ? indicator : /*#__PURE__*/ _jsx(Skeleton, {
                hideHeader: hideColumns,
                columns: columns.length,
                rows: skeletonRows
            }) : /*#__PURE__*/ _jsx(TableLayout, {
                className: layoutClassName,
                children: /*#__PURE__*/ _jsx(RCTable, _objectSpread({
                    className: clss({
                        'hide-column': hideColumns
                    }, className),
                    prefixCls: "ex-table",
                    columns: columns,
                    rowKey: getRowKey,
                    emptyText: getEmptyText,
                    data: data,
                    expandable: expandable
                }, rest))
            }),
            pageOpt && Number(pageOpt === null || pageOpt === void 0 ? void 0 : pageOpt.total) > Number(pageOpt === null || pageOpt === void 0 ? void 0 : pageOpt.pageSize) && /*#__PURE__*/ _jsx(CustomPagination, _objectSpread({}, pageOpt))
        ]
    }));
}
export default Table;
